import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import { theme } from "../../theme";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  i18n: theme.i18n.reducer,
  builder: theme.builder.reducer
});
